import { BaseEnum } from "../BaseEnum";

// Mirror of the backend Chazuke.Shared.Enums.Dsr.FacilityMatchOutcome enum.
// The API serializes enums as camelCase strings (JsonStringEnumConverter), so the
// codes here must match the serialized form exactly.
export class DsrFacilityMatchOutcome extends BaseEnum {
  static MATCHED = "matched";
  static LEGAL_SEAT_FALLBACK = "legalSeatFallback";
  static NO_MATCH = "noMatch";

  static Codes = [this.MATCHED, this.LEGAL_SEAT_FALLBACK, this.NO_MATCH];

  static _labelKeys = [
    "dsr-match-auto",
    "dsr-match-fallback",
    "dsr-match-to-assign",
  ];
}
